module.exports = __webpack_public_path__ + "static/media/Top_Up.fb3bab29.svg";